import React from 'react';
import PropTypes from 'prop-types';

import FilterNumberPair from 'components/search_sidebar/filter_number_pair';
import FilterSelect from 'components/search_sidebar/filter_select';
import FilterDatePickerPair from 'components/search_sidebar/filter_datepicker_pair';

import { filterLabelMappings, filterKeyMappings } from 'bundles/research/index/research_constants';

export default class LeaseFilterGroup extends React.Component {
  static propTypes = {
    compsView: PropTypes.bool,
    leaseFilter: PropTypes.object.isRequired,
    leaseSpaceTypeMappings: PropTypes.array.isRequired,
    leaseTypeMappings: PropTypes.array.isRequired,
    leaseUnits: PropTypes.array.isRequired,

    onFilterChange: PropTypes.func.isRequired
  };

  render() {
    const {
      leaseFilter,
      leaseUnits,
      leaseSpaceTypeMappings,
      leaseTypeMappings,
      onFilterChange
    } = this.props;

    return (
      <div className="lease-container">
        <div className="top-buffer-sm row right-buffer-sm left-buffer-sm">
          <FilterNumberPair
            filter={leaseFilter}
            label={filterLabelMappings['leasePrice']}
            valueKeys={filterKeyMappings['leasePrice']}
            onChange={onFilterChange}
          />
        </div>
        <div className="row right-buffer-sm left-buffer-sm hidden-xs hidden-sm">
          <FilterSelect
            defaultValue={''}
            label="Lease Rate Units"
            options={leaseUnits}
            value={leaseFilter.leaseRateUnits}
            onChange={e => onFilterChange(e, 'leaseRateUnits')}
          />
        </div>
        <div className="row right-buffer-sm left-buffer-sm">
          <FilterNumberPair
            filter={leaseFilter}
            label={filterLabelMappings['leaseSize']}
            valueKeys={filterKeyMappings['leaseSize']}
            onChange={onFilterChange}
          />
        </div>
        <div className="row right-buffer-sm left-buffer-sm">
          <FilterDatePickerPair
            filter={leaseFilter}
            label={filterLabelMappings['leaseExecutionDate']}
            valueKeys={filterKeyMappings['leaseExecutionDate']}
            onChange={onFilterChange}
          />
        </div>
        <div className="row right-buffer-sm left-buffer-sm">
          <FilterDatePickerPair
            filter={leaseFilter}
            label={filterLabelMappings['leaseDate']}
            valueKeys={filterKeyMappings['leaseDate']}
            onChange={onFilterChange}
          />
        </div>
        <div className="row right-buffer-sm left-buffer-sm">
          <FilterDatePickerPair
            filter={leaseFilter}
            label={filterLabelMappings['leaseExpirationDate']}
            valueKeys={filterKeyMappings['leaseExpirationDate']}
            onChange={onFilterChange}
          />
        </div>
        <div className="row right-buffer-sm left-buffer-sm">
          <FilterSelect
            defaultValue={''}
            label={filterLabelMappings['leaseType']}
            options={leaseTypeMappings}
            placeholder="Select a Lease Type"
            value={leaseFilter.leaseType}
            onChange={e => onFilterChange(e, 'leaseType')}
          />
        </div>
        <div className="row right-buffer-sm left-buffer-sm">
          <FilterSelect
            defaultValue={''}
            label={filterLabelMappings['leaseSpaceType']}
            options={leaseSpaceTypeMappings}
            placeholder="Select a Lease Space Type"
            value={leaseFilter.leaseSpaceType}
            onChange={e => onFilterChange(e, 'leaseSpaceType')}
          />
        </div>
      </div>
    );
  }
}